export class BaseBookingReportFilter {
  search: string;
  bookingEventIds: number[];
  startDate?: Date | string;
  endDate?: Date | string;
}

export class BookingReportCalendarFilter extends BaseBookingReportFilter {
}

export class BookingReportTableFilter extends BaseBookingReportFilter {
  public static readonly DefaultPageSize = 10;

  startTime?: string;
  endTime?: string;
  pageNumber: number;
  pageSize: number;

  constructor(
    search: string = '',
    bookingEventIds: number[] = [],
    startDate: Date | string = null,
    endDate: Date | string = null,
    startTime: string = null,
    endTime: string = null,
    pageNumber: number = 0,
    pageSize: number = BookingReportTableFilter.DefaultPageSize,
  ) {
    super();

    this.search = search;
    this.bookingEventIds = bookingEventIds;
    this.startDate = startDate;
    this.endDate = endDate;
    this.startTime = startTime;
    this.endTime = endTime;
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
  }
}

export enum CalendarViewType {
  Day = 0,
  Week = 1,
  Month = 2,
}

export enum BookingReportViewType {
  Calendar = 0,
  List = 1,
}

export interface BookingPageParams {
  pageNumber: number;
  pageSize: number;
  search?: string;
  excludeIds: number[];
}
export interface BookingPageListItem {
  id: number;
  name: string;
  color: string;
}
